// @flow

/**
 * Module dependencies.
 */

import { Helmet } from 'react-helmet';
import { asset } from 'core/utils';
import React from 'react';

/**
 * `Props` type.
 */

type Props = {
  description: string,
  keywords: string,
  title: string
};

/**
 * `Metatags` component.
 */

function Metatags(props: Props): React$Element<*> {
  const { description, keywords, title } = props;
  const image = asset(require('client/assets/images/social-pic.jpg'));

  return (
    <Helmet>
      <title>{title}</title>

      <meta
        content={description}
        name={'description'}
      />

      <meta
        content={keywords}
        name={'keywords'}
      />

      <meta
        content={title}
        name={'title'}
      />

      <meta
        content={description}
        property={'og:description'}
      />

      <meta
        content={'image/jpeg'}
        property={'og:image:type'}
      />

      <meta
        content={image}
        property={'og:image'}
      />

      <meta
        content={'Wayfex'}
        property={'og:site_name'}
      />

      <meta
        content={title}
        property={'og:title'}
      />

      <meta
        content={'website'}
        property={'og:type'}
      />

      <meta
        content={'summary'}
        name={'twitter:card'}
      />

      <meta
        content={title}
        name={'twitter:title'}
      />

      <meta
        content={description}
        name={'twitter:description'}
      />

      <meta
        content={image}
        name={'twitter:image'}
      />
    </Helmet>
  );
}

/**
 * Export `Metatags` component.
 */

export default Metatags;



// WEBPACK FOOTER //
// ../src/client/components/core/metatags/index.js